// Certificate translations — English + course language pair
export const CERT_I18N = {
  English: {
    heading: "Certificate of Achievement",
    tierRibbon: (tier, level) => `${tier} Tier${level ? " · " + level : ""}`,
    presented: "This certificate is proudly presented to",
    completed: "For successfully completing the course",
    levelLabel: (l) => `Level ${l}`,
    director: "Director",
    signedBy: (name, date) => `Digitally signed by ${name} on ${date}`,
    verifyAt: "Verify at",
    issued: "Issued",
    no: "№",
    tags: { bronze: "Foundation", silver: "Intermediate", gold: "Advanced", platinum: "Mastery" },
  },
  Spanish: {
    heading: "Certificado de Logro",
    tierRibbon: (tier, level) => `Nivel ${tier}${level ? " · " + level : ""}`,
    presented: "Este certificado se otorga con orgullo a",
    completed: "Por haber completado con éxito el curso",
    levelLabel: (l) => `Nivel ${l}`,
    director: "Director",
    signedBy: (name, date) => `Firmado digitalmente por ${name} el ${date}`,
    verifyAt: "Verificar en",
    issued: "Emitido",
    no: "№",
    tags: { bronze: "Fundamentos", silver: "Intermedio", gold: "Avanzado", platinum: "Maestría" },
  },
  French: {
    heading: "Certificat de Réussite",
    tierRibbon: (tier, level) => `Niveau ${tier}${level ? " · " + level : ""}`,
    presented: "Ce certificat est fièrement décerné à",
    completed: "Pour avoir suivi avec succès le cours",
    levelLabel: (l) => `Niveau ${l}`,
    director: "Directeur",
    signedBy: (name, date) => `Signé numériquement par ${name} le ${date}`,
    verifyAt: "Vérifier sur",
    issued: "Émis le",
    no: "№",
    tags: { bronze: "Fondation", silver: "Intermédiaire", gold: "Avancé", platinum: "Maîtrise" },
  },
  German: {
    heading: "Leistungszertifikat",
    tierRibbon: (tier, level) => `${tier}-Stufe${level ? " · " + level : ""}`,
    presented: "Dieses Zertifikat wird stolz verliehen an",
    completed: "Für den erfolgreichen Abschluss des Kurses",
    levelLabel: (l) => `Niveau ${l}`,
    director: "Direktor",
    signedBy: (name, date) => `Digital signiert von ${name} am ${date}`,
    verifyAt: "Verifizieren unter",
    issued: "Ausgestellt",
    no: "Nr.",
    tags: { bronze: "Grundlagen", silver: "Mittelstufe", gold: "Fortgeschritten", platinum: "Meisterschaft" },
  },
  Italian: {
    heading: "Certificato di Merito",
    tierRibbon: (tier, level) => `Livello ${tier}${level ? " · " + level : ""}`,
    presented: "Questo certificato è orgogliosamente conferito a",
    completed: "Per aver completato con successo il corso",
    levelLabel: (l) => `Livello ${l}`,
    director: "Direttore",
    signedBy: (name, date) => `Firmato digitalmente da ${name} il ${date}`,
    verifyAt: "Verifica su",
    issued: "Emesso",
    no: "№",
    tags: { bronze: "Fondamenti", silver: "Intermedio", gold: "Avanzato", platinum: "Maestria" },
  },
  Mandarin: {
    heading: "结业证书",
    tierRibbon: (tier, level) => `${tier}级别${level ? " · " + level : ""}`,
    presented: "兹证明以下学员",
    completed: "已成功完成课程",
    levelLabel: (l) => `${l} 级`,
    director: "校长",
    signedBy: (name, date) => `由 ${name} 于 ${date} 数字签署`,
    verifyAt: "验证网址",
    issued: "签发日期",
    no: "编号",
    tags: { bronze: "基础", silver: "中级", gold: "高级", platinum: "精通" },
  },
  Japanese: {
    heading: "修了証書",
    tierRibbon: (tier, level) => `${tier}レベル${level ? " · " + level : ""}`,
    presented: "この証書を以下の方に授与します",
    completed: "以下のコースを優秀な成績で修了されました",
    levelLabel: (l) => `${l} レベル`,
    director: "校長",
    signedBy: (name, date) => `${name} により ${date} に電子署名`,
    verifyAt: "検証先",
    issued: "発行日",
    no: "番号",
    tags: { bronze: "基礎", silver: "中級", gold: "上級", platinum: "熟達" },
  },
  Russian: {
    heading: "Сертификат об окончании",
    tierRibbon: (tier, level) => `Уровень ${tier}${level ? " · " + level : ""}`,
    presented: "Настоящий сертификат вручается",
    completed: "За успешное завершение курса",
    levelLabel: (l) => `Уровень ${l}`,
    director: "Директор",
    signedBy: (name, date) => `Цифровая подпись: ${name}, ${date}`,
    verifyAt: "Проверить на",
    issued: "Дата выдачи",
    no: "№",
    tags: { bronze: "Основы", silver: "Средний", gold: "Продвинутый", platinum: "Мастерство" },
  },
  Montenegrin: {
    heading: "Sertifikat o završetku",
    tierRibbon: (tier, level) => `${tier} nivo${level ? " · " + level : ""}`,
    presented: "Ovaj sertifikat se sa ponosom dodjeljuje",
    completed: "Za uspješno završen kurs",
    levelLabel: (l) => `Nivo ${l}`,
    director: "Direktor",
    signedBy: (name, date) => `Digitalno potpisao ${name} dana ${date}`,
    verifyAt: "Provjerite na",
    issued: "Izdato",
    no: "Br.",
    tags: { bronze: "Osnove", silver: "Srednji", gold: "Napredni", platinum: "Majstorstvo" },
  },
  German: {
    heading: "Abschlusszertifikat",
    tierRibbon: (tier, level) => `${tier}-Stufe${level ? " · " + level : ""}`,
    presented: "Dieses Zertifikat wird mit Stolz verliehen an",
    completed: "Für den erfolgreichen Abschluss des Kurses",
    levelLabel: (l) => `Niveau ${l}`,
    director: "Direktor",
    signedBy: (name, date) => `Digital signiert von ${name} am ${date}`,
    verifyAt: "Verifizieren unter",
    issued: "Ausgestellt am",
    no: "Nr.",
    tags: { bronze: "Grundlagen", silver: "Mittelstufe", gold: "Fortgeschritten", platinum: "Meisterschaft" },
  },
  Turkish: {
    heading: "Başarı Sertifikası",
    tierRibbon: (tier, level) => `${tier} Kademe${level ? " · " + level : ""}`,
    presented: "İşbu sertifika gururla takdim edilir",
    completed: "Kursu başarıyla tamamladığı için",
    levelLabel: (l) => `Seviye ${l}`,
    director: "Müdür",
    signedBy: (name, date) => `${name} tarafından ${date} tarihinde dijital olarak imzalanmıştır`,
    verifyAt: "Doğrulama adresi",
    issued: "Veriliş",
    no: "No.",
    tags: { bronze: "Temel", silver: "Orta", gold: "İleri", platinum: "Uzmanlık" },
  },
};

// Map UI language codes (en, me, it, de, tr) to full names used in CERT_I18N keys
export const UI_CODE_TO_CERT_LANG = {
  en: "English",
  me: "Montenegrin",
  it: "Italian",
  de: "German",
  tr: "Turkish",
};

export function getCertI18n(language) {
  return CERT_I18N[language] || CERT_I18N.English;
}

export function isEnglish(language) {
  return !language || language === "English";
}
